const darkTheme = {
  background: '#061E1C',
  backgroundElement: '#0A2926',
  backgroundSelected: '#113E3A',
  surface: '#092522',
  surfaceElevated: '#123733',
  surfaceMuted: '#0D302C',
  surfaceStrong: '#16423D',
  border: '#28504B',
  borderStrong: '#47736D',
  text: '#F4F7F6',
  textSecondary: '#BCD2CF',
  textTertiary: '#8CA9A5',
  institutional: '#0C4E49',
  brand: '#6ADBCB',
  brandPressed: '#8AE5D8',
  brandSubtle: '#123F3A',
  action: '#32C9C1',
  actionPressed: '#6ADBCB',
  actionSubtle: '#123F3A',
  onAction: '#062F2D',
  highlight: '#6ADBCB',
  highlightSubtle: '#164640',
  success: '#68D8C4',
  successSubtle: '#123D37',
  warning: '#E0B363',
  warningSubtle: '#40341F',
  error: '#E08A95',
  errorSubtle: '#43282D',
  income: '#68D8C4',
  incomeSubtle: '#123D37',
  expense: '#E08A95',
  expenseSubtle: '#43282D',
  pending: '#E0B363',
  pendingSubtle: '#40341F',
  scrim: 'rgba(0, 0, 0, 0.64)',

  featuredSurface: '#102F31',
  featuredBorder: '#376A70',
  featuredTextSecondary: '#C6D8D5',
  featuredIconSurface: '#123E53',
  featuredIcon: '#37B0F0',
  onBrand: '#FFFFFF',
  onInstitutional: '#FFFFFF',
  onInstitutionalMuted: 'rgba(255, 255, 255, 0.72)',
  onInstitutionalSubtle: 'rgba(255, 255, 255, 0.64)',
  institutionalDivider: 'rgba(255, 255, 255, 0.16)',
  institutionalPressed: 'rgba(255, 255, 255, 0.10)',
  heroGlow: 'rgba(61, 132, 246, 0.26)',
  heroGradientStart: '#0A4541',
  heroGradientMiddle: '#0C4E49',
  heroGradientEnd: '#082F35',
  fabShadow: '#020E0D',
  toastShadow: '#000000',
  neutral: '#47736D',
  navy: '#0C4E49',

  // Aliases temporários: não constituem uma segunda paleta.
  white100: '#FFFFFF',
  gray100: '#0A2926',
  gray200: '#28504B',
  gray300: '#16423D',
  gray400: '#8CA9A5',
  gray500: '#BCD2CF',
  typography100: '#F4F7F6',
  typography200: '#BCD2CF',
  typography300: '#47736D',
  typography400: '#8CA9A5',
  typography500: '#BCD2CF',
  primaryColor: '#32C9C1',
  secondaryColor: '#8CA9A5',
  successColor: '#68D8C4',
  dangerColor: '#E08A95',
  infoColor: '#37B0F0',
  warningColor: '#E0B363',
  backgroundColor: '#061E1C',
  lightColor: '#16423D',
  textColor: '#F4F7F6',
  cardBackground: '#092522',
  listBackground: '#0D302C',
  modalBackground: '#092522',
  inputBackground: '#0D302C',
  inputBorder: '#28504B',
  inputFocusBorder: '#32C9C1',
  inputFocusShadow: 'rgba(50, 201, 193, 0.30)',
  navBackground: 'rgba(6, 30, 28, 0.92)',
};

export default darkTheme;
